<template>
  <div class="database">
    <Headers></Headers>
    <div
      class="banner"
      style="background: url(/static/banner/banner3.jpg) center"
    >
      <div class="box">
        <div class="left"></div>
        <div class="container">
          <div class="title">细胞系STR数据库在线比对</div>
          <div class="entitle">Online comparison of cell line STR database</div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="bottom">
      <div class="container">
        <div class="title">
          <span>温馨提示：</span>请登录后，填入下面对应基因座数据（多条数据请用‘
          ，’隔开，例如：12,13,14），点击在线对比按钮，即可查询
        </div>
        <div class="con">
          <el-form
            :inline="true"
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            action=""
          >
            <el-row :gutter="20">
              <el-col
                :xs="24"
                :sm="6"
                :md="4"
                :lg="4"
                v-for="(item, index) in titlelist"
                :key="index"
              >
                <el-form-item :label="item" :prop="item" class="item">
                  <el-input
                    :placeholder="item === 'Amel' ? '例：X,Y' : '例：12,13,14'"
                    v-model="ruleForm[item]"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24">
                <el-form-item class="btnbox">
                  <el-button type="primary" @click="submitForm('ruleForm')">
                    查询对比
                  </el-button>
                  <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="jieguo">
          <div class="jgtitle">
            您查询的数据对比结果为:
            <span v-if="iscontrast">没有相匹配的数据</span>
            <span v-if="!iscontrast && tableData.length > 0"
              >匹配度80%以上的数据条数有 {{ num }} 条</span
            >
          </div>
          <div class="jglist" v-if="tableData.length > 0">
            <el-table
              :data="tableData"
              border
              style="width: 100%"
              max-height="450"
            >
              <el-table-column fixed prop="Name" label="Name" width="100">
              </el-table-column>
              <el-table-column fixed prop="probability" label="Score">
              </el-table-column>
              <template v-for="(item, key) in tablelist">
                <el-table-column
                  :key="key"
                  :prop="item"
                  :label="item"
                ></el-table-column>
              </template>
            </el-table>
          </div>
          <unllimg v-else></unllimg>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import unllimg from '@/components/unllimg/unllimg.vue'
import service from './database.js'
import { setmeta } from '@/assets/js/setmeta'

export default {
  name: 'database',
  mixins: [setmeta],
  data () {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('数据不能为空'))
      } else {
        callback()
      }
    }
    return {
      num: 0,
      iscontrast: false,
      titlelist: [],
      tablelist: [],
      tableData: [],
      ruleForm: {
        Name: 'Query',
        probability: 'NA',
        Amel: '',
        D5S818: '',
        D13S317: '',
        D7S820: '',
        D16S539: '',
        vWA: '',
        TH01: '',
        TPOX: '',
        CSF1PO: ''
      },
      rules: {
        Amel: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ],
        D5S818: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ],
        D13S317: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ],
        D7S820: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ],
        D16S539: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ],
        vWA: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ],
        TH01: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ],
        TPOX: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ],
        CSF1PO: [
          { validator: checkAge, required: true, trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    Headers,
    Footer,
    unllimg
  },
  computed: {
    userid () {
      return this.$store.state.user.userInfo.id
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.$common.scrollstop()
          service.getDataContrast(this)
        } else {
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    close () {
      this.ishide = !this.ishide
      this.$common.scrollmove()
    }
  },
  created () {
    this.setMetaConfig({
      web_title: `细胞系STR数据库在线比对-${this.$env.TITLE}`
    })
    service.getFiledList(this)
  }
}
</script>

<style lang="scss" scoped>
@import "./database";
</style>



// WEBPACK FOOTER //
// src/views/database/database.vue